export const TABLE_RESIZE = 'TABLE_RESIZE';
export const CHANGE_TEXT = 'CHANGE_TEXT';
export const APPLY_STYLE = 'APPLY_STYLE';
export const CHANGE_STYLES = 'CHANGE_STYLES';
export const CHANGE_TITLE = 'CHANGE_TITLE';
export const UPDATE_DATE = 'UPDATE_DATE';
